<div class="hint">Please select all that apply</div>
<ion-list>
  @for (option of checkboxOptions; track option) {
    <ion-item lines="none">
      <ion-label>{{ option.label }}</ion-label>
      <ion-checkbox
        color="secondary"
        slot="start"
        [value]="option.value"
        [(ngModel)]="option.isChecked"
      (ngModelChange)="onCheckBoxChanged(option.value, input)"></ion-checkbox>
    </ion-item>
  }
</ion-list>
<ion-item class="other-container" [ngClass]="!showOther ? 'ion-hide' : ''" lines="none">
  <ion-input
    #input
    tabindex="-1"
    type="text"
    autocorrect="on"
    autocapitalize="on"
    enterkeyhint="done"
    maxlength="100"
    class="questions"
    label="Please provide details (required)"
    labelPlacement="stacked"
    [formControl]="field"
    (keyup)="onKeyUp($event)"
  (click)="onClick($event)"></ion-input>
</ion-item>
<ion-item class="character-count" [ngClass]="!showOther ? 'ion-hide' : ''" lines="none">{{ length }}/100</ion-item>
